import { AirValidationSector } from '@app/entities/air-validation.response';
import { FlightItem } from '@app/entities/flight-results';

export function upsellDesktopSelectRoutes(sectors: AirValidationSector[]): FlightItem[] {
  const selectedRoutes = [];
  if (sectors) {
    sectors?.forEach(sector => {
      sector.Flights.forEach(flight => {
        selectedRoutes.push({
          AirlineCode: flight.AirlineCode,
          ArrivalAirport: flight.ArrivalAirport,
          ArrivalDate: flight.ArrivalDate,
          DepartureAirport: flight.DepartureAirport,
          DepartureDate: flight.DepartureDate,
          FareFamilies: flight.FareFamilies,
          FlightKeys: `${flight.AirlineCode}${flight.Number}`,
          SectorNumber: sector.SectorNumber
        } as FlightItem);
      });
    });
  }
  return selectedRoutes;
}
